import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {required} from "../../../../../../shared/utils";
import { ContactTypes, ContactDropdownButtonComponent } from "../../../../template/contact-dropdown-button/contact-dropdown-button.component";
import {ContactSendingFormNode} from "../../../node-delegator/nodes/menu/contact-sending/contactSending";
import cloneDeep from 'lodash/cloneDeep';
import { DeleteContact, ContactsTemplateComponent } from "../../../../template/contacts-template/contacts-template.component";
import { Contact } from '../../translator/translatorUtils';
import { ActiveFormDirective } from '../../../../../../shared/directives/active-form/active-form.directive';

@Component({
    selector: 'send-contact-card',
    templateUrl: './send-contact-card.component.html',
    styleUrls: ['./send-contact-card.component.scss'],
    imports: [ReactiveFormsModule, ActiveFormDirective, ContactsTemplateComponent, ContactDropdownButtonComponent]
})
export class SendContactCardComponent implements OnInit {

    @Output() close: EventEmitter<any> = new EventEmitter();
    @Output() send: EventEmitter<Contact> = new EventEmitter();

    contactInfo: UntypedFormGroup;
    contactInfoRawData = {}

    constructor(private fb: UntypedFormBuilder) {
    }

    ngOnInit(): void {
        this.contactInfo = this.fb.group({
            addresses: new UntypedFormArray([]),
            emails: new UntypedFormArray([]),
            org: new UntypedFormArray([]),
            phones: new UntypedFormArray([]),
            urls: new UntypedFormArray([]),
            birthdays: new UntypedFormArray([]),
            firstName: new UntypedFormControl('', [required('first name')]),
            lastName: new UntypedFormControl('', [required('last name')]),
            formattedName: new UntypedFormControl('', [required('formatted name')]),
        });

        this.contactInfoRawData = this.contactInfo.getRawValue()
    }

    closeSendContact() {
        this.close.emit();
    }

    addContact(contact: ContactTypes) {
        let newContact = undefined;
        const canEdit = {
            canEditFlows: true,
            canEditMenuTextOnly: true,
            canEdit: true,
        }
        switch (contact) {
            case ContactTypes.ADDRESS:
                newContact = ContactSendingFormNode.getAddressTemplate(canEdit);
                break
            case ContactTypes.BIRTHDAY:
                newContact = ContactSendingFormNode.getBirthdayTemplate(canEdit);
                break
            case ContactTypes.EMAIL:
                newContact = ContactSendingFormNode.getEmailTemplate(canEdit);
                break
            case ContactTypes.ORGANISATION:
                newContact = ContactSendingFormNode.getOrganisationTemplate(canEdit);
                break
            case ContactTypes.PHONE:
                newContact = ContactSendingFormNode.getPhoneTemplate(canEdit);
                break
            case ContactTypes.URL:
                newContact = ContactSendingFormNode.getUrlTemplate(canEdit);
                break
        }

        if (newContact !== undefined) {
            const contactList = this.contactInfo.controls[contact] as UntypedFormArray;
            contactList.push(newContact);
            this.contactInfoRawData = cloneDeep(this.contactInfo.getRawValue());
        }
    }

    deleteTemplate(_: DeleteContact) {
        this.contactInfoRawData = cloneDeep(this.contactInfo.getRawValue());
    }

    sendContact() {
        const rawValue = this.contactInfo.getRawValue();
        const contact: Contact = {
            contentType: 'contact',
            addresses: rawValue.addresses,
            birthday: rawValue.birthdays[0]?.birthday,
            emails: rawValue.emails,
            phones: rawValue.phones,
            urls: rawValue.urls,
            org: rawValue.org[0],
            name: {
                firstName: rawValue.firstName,
                lastName: rawValue.lastName,
                formattedName: rawValue.formattedName
            }
        }
        this.send.emit(contact)
    }
}
